import React from 'react';
const BreadcrumbContext = /*#__PURE__*/React.createContext({});
export default BreadcrumbContext;